var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"c-main--flex-1"},[_c('div',{staticClass:"c-cis-panels"},_vm._l((_vm.panels),function(panel){return _c('sessionPanel',{key:panel.id,staticClass:"c-cis-panels__item",attrs:{"panel":panel}})}),1)])
}
var staticRenderFns = []

export { render, staticRenderFns }